import React from 'react';

const Diners = ({ width = 32, height = 32, className = "" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 32 32"
      className={className}
    >
      <g className="nc-icon-wrapper">
        <rect x="2" y="7" width="28" height="18" rx="3" ry="3" fill="#fff" strokeWidth="0"></rect>
        <path d="m27,7H5c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3v-12c0-1.657-1.343-3-3-3Zm2,15c0,1.103-.897,2-2,2H5c-1.103,0-2-.897-2-2v-12c0-1.103.897-2,2-2h22c1.103,0,2,.897,2,2v12Z" strokeWidth="0" opacity=".15"></path>
        <path d="m27,8H5c-1.105,0-2,.895-2,2v1c0-1.105.895-2,2-2h22c1.105,0,2,.895,2,2v-1c0-1.105-.895-2-2-2Z" fill="#fff" opacity=".2" strokeWidth="0"></path>
        <path d="m15.111,22c-3.32.015-6.052-2.674-6.052-5.948,0-3.578,2.732-6.053,6.052-6.052h1.556c3.28,0,6.274,2.473,6.274,6.052,0,3.273-2.994,5.948-6.274,5.948h-1.556Zm.014-11.504c-3.034.001-5.492,2.459-5.492,5.493,0,3.033,2.458,5.491,5.492,5.492,3.034,0,5.492-2.458,5.493-5.492,0-3.034-2.459-5.492-5.493-5.493m-1.247,8.741v-6.497c-1.305.503-2.231,1.766-2.235,3.249.003,1.483.929,2.746,2.235,3.248m4.729-3.248c-.003-1.484-.93-2.748-2.236-3.25v6.499c1.307-.502,2.234-1.766,2.236-3.25" fill="#0d4e96" strokeWidth="0"></path>
      </g>
    </svg>
  );
};

export default Diners; 